import React from "react";

import { DpLeavePayer, LEAVE_PAYER_LABELS } from "../api/leavesApi";

const TONE: Record<DpLeavePayer, string> = {
  EMPREGADOR: "dpBadge--blue",
  INSS: "dpBadge--orange",
  NENHUM: "dpBadge--gray",
};

/** Quem paga os dias do afastamento: empresa, INSS ou ninguém. */
export default function LeavePayerBadge({ payer }: { payer: DpLeavePayer }) {
  return <span className={`dpBadge ${TONE[payer]}`}>{LEAVE_PAYER_LABELS[payer]}</span>;
}
